<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text>
      <v-container fluid class="jwt-scanner">
        <v-row>
          <v-col>
            <v-btn block
                   color="primary"
                   @click="fileInput.click()">
              {{ $t('camera_capture.fallback') }}
            </v-btn>
            <input ref="fileInput" type="file"
                   accept="image/jpeg, image/png, image/jpg"
                   capture="environment"
                   @change="fileUploaded"
                   class="invisible">
          </v-col>
        </v-row>
        <v-row>
          <v-divider></v-divider>
          <span class="mx-4">{{ $t('jwt_scanner.or') }}</span>
          <v-divider></v-divider>
        </v-row>
        <v-select outlined
                  :items="cameraOptions"
                  v-model="selectedCameraDeviceId"></v-select>
        <v-row>
          <v-col>
            <WebCam ref="webCam"
                    width="300"
                    height="300"
                    :device-id="selectedCameraDeviceId"
                    @cameras="onCameraListReady"></WebCam>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel"
             class="mr-3"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="capture"
             class="mr-3"
             depressed
             large>
        {{ $t('camera_capture.capture') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, ref} from "@vue/composition-api";
import {WebCam} from "vue-web-cam";

export default {
  name: 'CameraCaptureModal',
  components: {WebCam},
  props: {},
  setup(props, {root, emit}) {
    // Init
    const cancel = function () {
      emit('submit', undefined);
    };

    const webCam = ref(null);
    const selectedCameraDeviceId = ref(null);
    const cameras = ref([]);
    const cameraOptions = computed(() => {
      return cameras.value.map((c) => {
        return {text: c.label, value: c.deviceId};
      })
    })
    const onCameraListReady = function (c) {
      cameras.value = c;

      if (c.length > 0) {
        selectedCameraDeviceId.value = c[0].deviceId;
      }
    }
    const capture = async function () {
      const base64 = webCam.value.capture();

      const response = await fetch(base64);
      const blob = await response.blob();
      emit('submit', new File([blob], 'pic.jpeg', {type: 'image/jpeg'}));
    }

    const fileInput = ref(null);
    const fileUploaded = function (e) {
      if (e.target.files[0]) {
        let file = e.target.files[0];
        let blob = file.slice(0, file.size, {type: file.type});

        let components = file.name.split('.');
        let extension = components[components.length - 1];

        try {
          emit('submit', new File([blob], `${props.fileName || 'upload'}.${extension}`, {type: file.type}))
        } catch (err) {
          let f = new Blob([blob], {type: file.type});
          f.lastModifiedDate = new Date();
          f.name = `${props.fileName || 'upload'}.${extension}`;
          emit('submit', f);
        }

        fileInput.value.value = null
      }
    };

    return {
      cancel,

      webCam,
      selectedCameraDeviceId,
      cameraOptions,
      onCameraListReady,
      capture,

      fileInput,
      fileUploaded,
    }
  }
}
</script>

<style lang="less">
.jwt-scanner {
  .qr-code-reader-overlay {
    display: inline-table;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    label {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      color: white;
    }
  }
}
</style>
